/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
    /**
     * Overwolf game ID (matches overwolfId in steam-matches.json)
     * @type {string}
     * @memberof InlineObject14
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineObject14
     */
    steamAppId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    steamName?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    shortDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject14
     */
    genres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject14
     */
    developers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject14
     */
    publishers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    releaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    steamHeaderImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    steamCapsuleImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    steamBackground?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject14
     */
    steamScreenshots?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject14
     */
    categories?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InlineObject14
     */
    recommendations?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject14
     */
    achievements?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    website?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InlineObject14
     */
    timeTrackedGame?: boolean;
}

export function InlineObject14FromJSON(json: any): InlineObject14 {
    return InlineObject14FromJSONTyped(json, false);
}

export function InlineObject14FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject14 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'steamAppId': !exists(json, 'steamAppId') ? undefined : json['steamAppId'],
        'steamName': !exists(json, 'steamName') ? undefined : json['steamName'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'genres': !exists(json, 'genres') ? undefined : json['genres'],
        'developers': !exists(json, 'developers') ? undefined : json['developers'],
        'publishers': !exists(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'steamHeaderImage': !exists(json, 'steamHeaderImage') ? undefined : json['steamHeaderImage'],
        'steamCapsuleImage': !exists(json, 'steamCapsuleImage') ? undefined : json['steamCapsuleImage'],
        'steamBackground': !exists(json, 'steamBackground') ? undefined : json['steamBackground'],
        'steamScreenshots': !exists(json, 'steamScreenshots') ? undefined : json['steamScreenshots'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
        'recommendations': !exists(json, 'recommendations') ? undefined : json['recommendations'],
        'achievements': !exists(json, 'achievements') ? undefined : json['achievements'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'timeTrackedGame': !exists(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
    };
}

export function InlineObject14ToJSON(value?: InlineObject14 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gameId': value.gameId,
        'name': value.name,
        'steamAppId': value.steamAppId,
        'steamName': value.steamName,
        'shortDescription': value.shortDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'steamHeaderImage': value.steamHeaderImage,
        'steamCapsuleImage': value.steamCapsuleImage,
        'steamBackground': value.steamBackground,
        'steamScreenshots': value.steamScreenshots,
        'categories': value.categories,
        'recommendations': value.recommendations,
        'achievements': value.achievements,
        'website': value.website,
        'timeTrackedGame': value.timeTrackedGame,
    };
}


